import { ReactElement } from 'react';

import * as prismicR from '@prismicio/richtext';

import { IProps } from './types';
import * as S from './styles';

export function SliceHtmlEmbded({ slice: { primary } }: IProps): ReactElement {
  return (
    <S.Wrapper
      className="slice-item slice-html-embded"
      dangerouslySetInnerHTML={{ __html: prismicR.asText(primary.html) }}
    />
  );
}

SliceHtmlEmbded.componentName = 'htmlembded';
